import React from 'react'
import promoBackImg from "./images/back img 1.jpg"
import promoProdImg from "./images/headphone-black.png"
import "./promo.css"

function Promo() {
  return (
    <div className='promo-container'>
    <img src={promoBackImg} alt="" className="promo-back-img" />
      <div className="promo-content">
        <div className="promo-prod">
            <img src={promoProdImg} alt="" className="promo-prod-img" />
            <div className="promo-text-content">
                <div className="promo-text">
                    <h2 className="promo-heading">ACTIVE NOISE CANCELING</h2>
                    <p className="promo-start-from">STARTS FROM &#8377; 1999.00</p>
                    <p className="promo-desc">New Release Wireless Headphone from SoundPro Sound Technology. Using Bluetooth 5.0, Noice Canceling and APTX Technology to make a good experience when listening to music.</p>
                    <button className="promo-prod-btn">SHOP HERE</button>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Promo
